<template>
  <div class="useableCoupon">
    <div class="coupon-title">选择优惠券</div>
    <div class="coupon-list">
      <!-- 优惠券单元格 -->
      <div :class="item.canUse"  v-for="item in coupons" :key="item.id">
          <tr class="coupon-head">
              <td v-if="item.type!=1" class="coupon-amount">{{item.faceValue0}}元</td>
              <td v-if="item.type==1" class="coupon-amount">{{item.faceValue0}}折</td>
              <td class="coupon-name">{{item.title}}</td>
              <td class="coupon-choose">
                  <input v-if="needPay>=item.doorsill" type="checkbox" :checked='checkIds.indexOf(item.no)>=0' @click="checkedOne(item.no,item)" :name="item.name"  :value="item.no"/>
             </td>
          </tr>
           <tr class="coupon-body">
              <td class="coupon-condition"><span v-if="needPay<item.doorsill">不可用:!</span>满{{item.doorsill}}元可用</td>
              <td class="coupon-valid">到期时间:{{item.end}}</td>
          </tr>
      </div>  

      </div>
      <div class="coupon-btn">
        <van-button @click="chooseCoupon">确定选择</van-button>
      </div>
  </div>
</template>

<script>
  import {mySessionStorage} from '@/utils/storage.js';
  export default { 
    props:{
        userId:{
          type:String,
          default:''
        },
        payScene:{
          type:String,
          default:''
        },
        companyId:{
          type:String,
          default:''
        },
        carParkId:{
          type:String,
          default:''
        },
        needPay:{
          type:String,
          default:''
        },
        orderId:{
          type:String,
          default:''
        }


        }, 
    data() {
      return {
        showList:false,
        chosenCoupon: -1,
        coupons: [],
        checkIds:[],
        checkCoupon:{}
      };
    },
    methods: {
      getMyCoupon() {
        let params = {
          userId: this.userId,
          payScene:this.payScene,
          companyId:this.companyId,
          carParkId:this.carParkId
        };
        this.$http
          .post(this.$api.useableCouponUrl, params)
          .then(res => {
            if (res.code == 200) {
              let couponList=res.data
              for(var i=0;i<couponList.length;i++){
                if(this.needPay<couponList[i].doorsill){
                  couponList[i].canUse='coupon-con cant'
                }
                else{
                 couponList[i].canUse='coupon-con can'
                }
                
              }
              console.log(couponList)
              this.coupons=couponList;
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      checkedOne(id,item){
        this.checkIds=[],
        this.checkIds.push(id);
        this.checkCoupon=item;
      },
      onChange(index) {
      this.showList = false;
      this.chosenCoupon = index;
      },
      onExchange(code) {
      this.coupons.push(coupon);
      },
      chooseCoupon(){
        var couponId=this.checkIds[0];
        console.log(couponId);
        console.log(this.checkCoupon);
        var needpayNew=0;
        var couponStr=""
        if(this.checkCoupon.type==1){
          //折扣券
          needpayNew=this.discountCalc(this.needPay,this.checkCoupon.faceValue0);
          couponStr=this.checkCoupon.faceValue0+"折";
        }
        else{
          //代金券
          needpayNew=this.cashCalc(this.needPay,this.checkCoupon.faceValue0);
          couponStr="-"+this.checkCoupon.faceValue0
        }
        var backStr={
          couponStr:couponStr,
          needpayNew:needpayNew
        };
        this.useCoupon(backStr);
        
      },
      //使用优惠券
      useCoupon(backStr){
        let params = {
          id: this.checkCoupon.id,
          type:this.checkCoupon.type,
          appUserId:this.userId,
          faceValue0:this.checkCoupon.faceValue0,
          orderIds:this.orderId,
          roadParkingRange:this.checkCoupon.roadParkingRange,
          parkParkingRange:this.checkCoupon.parkParkingRange,
          roadEscapeRange:this.checkCoupon.roadEscapeRange,
          parkSubscribeStatus:this.checkCoupon.parkSubscribeStatus,
          parkOnlineCardStatus:this.checkCoupon.parkOnlineCardStatus,
          roadOnlineCardStatus:this.checkCoupon.roadOnlineCardStatus,
          walletRechargeStatus:this.checkCoupon.walletRechargeStatus
        };
        console.log("使用优惠券：",params);
        this.$http
          .post(this.$api.ueseCouponUrl, params)
          .then(res => {
            if (res.code == 200) {
              this.$emit('event1', backStr);
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      //折扣券计算
      discountCalc(original,faceValue0){
        let newMoney=original*faceValue0/10;
        newMoney=Math.floor(parseFloat(newMoney*100))/100;
        newMoney=newMoney>0?newMoney:0;
        return newMoney;
      },
      //代金券计算
      cashCalc(original,faceValue0){
        let newMoney=original-faceValue0;
        newMoney=Math.floor(parseFloat(newMoney*100))/100;
        newMoney=newMoney>0?newMoney:0;
        return newMoney;
      }

    },
    created() {},
    mounted() {
      this.getMyCoupon();
    },
    computed: {
      
    },
    watch: {
     
    }
  };
</script>

<style>
.useableCoupon{
    margin: 0;
    background-color: #e5e5e5;
}
.coupon-title{
  text-align: center;
  color: red;
  height: 40px;
  line-height: 40px;
  width: 100%;
}
.coupon-list{
    width: 100%;
    height: calc(90vh - 100px);
    overflow-y: scroll;
}
.coupon-btn{
  height: 60px;
  width: 100%;
  background-color: #e5e5e5;
}
.coupon-btn .van-button{
  color: #FFF;
  background-color: rgb(244, 123, 32);;
  width: 98%;
  margin-left: 1%;
  height: 48px;
  margin-top: 6px;
  border-radius: 4px;
}
.coupon-con{
    width: 98%;
    height: 100px;
    margin-left: 1%;
    border-radius: 8px;
    margin-bottom: 8px;
}
.cant{
   background-color: #eee;
}
.can{
  background-color: #FFF;
}
.coupon-con tr{
    display: inline-block;
}
.coupon-head{
    height: 60px;
    width: 100%;
    border-bottom: 1px rgb(153, 26, 26) dashed;
    /* float: left; */
}
.coupon-amount{
    width: 30%;
    height: 60px;
    display: inline-block;
    text-align: center;
    line-height: 60px;
    color: rgb(235, 27, 27);
    font-size: 24px;
    font-weight: bold;
    vertical-align: top;
}
.coupon-name{
    width: 50%;
    height: 60px;
    line-height: 60px;
    display: inline-block;
    color: #000;
    font-weight: bold;
    text-align: right;
    vertical-align: top;
}
.coupon-choose{
    width: 15%;
    height: 60px;
    display: inline-block;
    line-height: 60px;
    vertical-align: top;
    text-align: center;
}

/* .coupon-choose input[type=checkbox]::after {
        background-color: rgb(230, 15, 15);
        color: rgb(224, 20, 20);
} */
/* input[type=checkbox]:checked::after {
        background-color: rgb(235, 27, 27);
        border-color: rgb(235, 27, 27);
        color: red;
} */

.coupon-condition{
    width: 35%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    display: inline-block;
    color: rgb(235, 27, 27);
    vertical-align: top;
    font-size: 14px;
}
.coupon-valid{
    width: 60%;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    display: inline-block;
    text-align: right;
    vertical-align: top;
}
.coupon-body{
    height: 40px;
    width: 98%;
    float: left;   
}


</style>



// WEBPACK FOOTER //
// src/components/coupon/useableCoupon.vue